import "./App.css";

function App() {
  return (
    <div className="App">
      <div className="card-container">
        <iframe
          src="https://suitecrm.communitycx.org/public/"
          title="SuiteCRM Embedded View"
          className="card-iframe"
        />
      </div>
    </div>
  );
}

export default App;
